var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 7L0.333008 3.5L3.83301 0L4.64967 0.845833L2.57884 2.91667H9.66634V4.08333H2.57884L4.64967 6.15417L3.83301 7Z",
    fill: "#B0B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftAlt2);
export default __webpack_public_path__ + "static/media/arrow_left_alt-2.10c92a29.svg";
export { ForwardRef as ReactComponent };